<template>
	<bsh-modal 
		:titulo="title"
		:name="name">
		<template v-slot:default>
	        <categoria-form
	        	:dados="dados" 
	        	:name="name" 
	        	:errors="errors">
	        </categoria-form>
	    </template>
	    <template v-slot:footer>
        	<button 
				ref="btnRequest"
        		type="button" 
        		class="btn btn-primary" 
        		@click="update">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	export default {
		props: {
	        title: {
	            type: String,
	            default: 'Editar Categoria'
	        },
	        link: {
	            type: String,
	        },
	        dado_id: {
	        	type: Number,
	        }
	    },
		data(){
			return {
				dados: [],
				name: 'update_categoria',
				errors: []
			}
		}, 
		methods: {
			update(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
	            axios.put(this.$url+'/'+this.link+'/update/'+this.dado_id, (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	},
        	getDados(){
	            axios.get(this.$url+'/'+this.link+'/show/'+this.dado_id)
	            .then(response => {
	                this.dados = response.data
	            })
			}
		},
		watch: {
			dado_id(){
				this.getDados()
			}
		}
	}
</script>